export default function routerConfiguration(
  $urlRouterProvider,
  $stateProvider,
  $httpProvider,
  $locationProvider) {
  'ngInject';

  $httpProvider.interceptors.push('interceptor');

  $locationProvider.html5Mode(false).hashPrefix('!');
  // $httpProvider.defaults.cache = true;
  $stateProvider
    .state('app', {
      abstract: true,
      views: {
        '': {
          template: `<ui-view></ui-view>`
        }
      }
    })
    .state('auth', {
      abstract: true,
      views: {
        '': {
          template: `<ui-view></ui-view>`
        },
        footer: {
          template: `<mo-footer></mo-footer>`
        },
      }
    })
    .state('site', {
      abstract: true,
      views: {
        '': {
          template: `<ui-view></ui-view>`
        },
        footer: {
          template: `<mo-footer></mo-footer>`
        },
      }
    })
    .state('course', {
      abstract: true,
      views: {
        '': {
          template: `<ui-view autoscroll='true'></ui-view>`
        },
        footer: {
          template: `<mo-footer></mo-footer>`
        },
      }
    })

  $urlRouterProvider.otherwise('/');

}



// WEBPACK FOOTER //
// ./client/app/core/core.route.js